import {Permissions} from '../enums/permissions';

interface QuoteUser {
  role_id?: string | number;
  permission?: string;
}

export function hasQuotePermission(user: QuoteUser | null | undefined, permission: string): boolean {
  return ['1', '2', '4'].includes(String(user?.role_id ?? ''))
    && (user?.permission?.split(',') ?? []).includes(permission);
}

export function isQuotePermission(permission: string): boolean {
  return [Permissions.ViewQuotes, Permissions.ViewQuoteDetails, Permissions.QuoteActions]
    .includes(permission as Permissions);
}
